export const TYPES = '/types/{variable}' as const
export const TYPES_CHILD = '/types/{variable}/{child}' as const
